import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { ClientDashboardsProvider, ClientsProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const ClientsList = Loader(lazy(() => import('../../content/pages/Clients/ClientsList')));

const ClientCreate = Loader(lazy(() => import('../../content/pages/Clients/ClientCreate')));

const ClientUpdate = Loader(lazy(() => import('../../content/pages/Clients/ClientUpdate')));

const ClientDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/ClientDashboard')));

export const createClientsRoutes = () => ({
  path: 'clients',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['clientViewAll']} should404>
          <Navigate to="/clients/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['clientViewAll']} should404>
          <ClientsProvider>
            <ClientsList />
          </ClientsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `:clientId/update`,
      element: (
        <PermissionsGuard allowedPermissions={['clientUpdate']} should404>
          <ClientsProvider>
            <ClientUpdate />
          </ClientsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `:clientId/dashboard`,
      element: (
        <PermissionsGuard allowedPermissions={['clientDashboardView']} should404 ownClientId>
          <ClientsProvider>
            <ClientDashboardsProvider>
              <ClientDashboard />
            </ClientDashboardsProvider>
          </ClientsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'create',
      element: (
        <PermissionsGuard allowedPermissions={['clientCreate']} should404>
          <ClientsProvider>
            <ClientCreate />
          </ClientsProvider>
        </PermissionsGuard>
      )
    }
  ]
});
